/* tslint:disable */
/* eslint-disable */
export enum AccountNumberType {
  BASIC_BANK_ACCOUNT_NUMBER = 'BASIC_BANK_ACCOUNT_NUMBER',
  INTERNATIONAL_BANK_ACCOUNT_NUMBER = 'INTERNATIONAL_BANK_ACCOUNT_NUMBER',
  WIRE = 'WIRE'
}
